// prettier-ignore

/**
 * @link https://shoesize.me/en/size_advisor_scripts/single_product
 * @link https://help.shoesize.me/zero-interaction-feature
 */
define([
    'uiComponent',
    'Magento_Customer/js/customer-data',
    /**
     * ShoeSize.Me could issue a recommendation immediately upon load, so ensure the event listeners are in place.
     * @see configurable-size-advisor.js
     */
    'configurable'
], function(Component, CustomerData) {
    'use strict';

    return Component.extend({
        initialize: function() {
            this._super();

            let script = document.createElement('script');
            script.async = 1;
            script.src = this.loaderUrl;
            script.text = `{
                shopID: "${this.shopID}",
                shoeID: "${this.shoeID}",
                locale: "${this.locale}",
                scale: "${this.scale}",
                zeroHash: "${this.getSizeAdvisorData('zeroHash')}",
                newRecommendation: function(recommendation){ jQuery(document).trigger("ssm:newRecommendation", recommendation) },
                inCart: function(recommendation){ jQuery(document).trigger("ssm:inCart", recommendation) }
            }`;
            document.head.appendChild(script);
        },

        getSizeAdvisorData: function(key) {
            const data = CustomerData.get('size-advisor')();
            return data.hasOwnProperty(key)? data[key] : '';
        }
    });
});
